// ─────────────────────────────────────────────────────────────────────────────
// SearchBoxCompo.jsx
// Reusable local search input — drop-in for any screen that needs a quick
// client-side filter bar.
//
// Props:
//   value        {string}    — controlled input value
//   onChange     {function}  — (newValue: string) => void   ← plain string, not event
//   placeholder  {string}    — input placeholder  (default: "Search...")
//   style        {object}    — optional override for the outer wrapper
// ─────────────────────────────────────────────────────────────────────────────

import { blueWhiteShade, fadeBlueWhite, fadeViolet, white } from "../../config/ColorObj";



const defaultStyles = {
    wrapper: {
        marginBottom: 12,
        marginLeft: 5,
    },
    searchWrap: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        width: "100%",
        maxWidth: 250,
    },
    input: {
        width: "100%",
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 7,
        paddingBottom: 7,
        fontSize: 13,
        border: "1px solid #e2e8f0",
        borderRadius: 6,
        outline: "none",
        color: blueWhiteShade,
        backgroundColor: white,
        transition: "border-color .15s",
    },
};

// ─── Component ────────────────────────────────────────────────────────────────
const SearchBoxCompo = ({
    value,
    onChange,
    placeholder = "Search...",
    style = {},
}) => {
    return (
        <div style={{ ...defaultStyles.wrapper, ...style }}>
            <div style={defaultStyles.searchWrap}>
                <input
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    style={defaultStyles.input}
                    onFocus={(e) => (e.target.style.borderColor = fadeViolet)}
                    onBlur={(e) => (e.target.style.borderColor = fadeBlueWhite)}
                />
            </div>
        </div>
    );
};

export default SearchBoxCompo;